<script setup lang="ts">
export interface FooterLink {
  to?: string
  href?: string
  label: string
}

export interface FooterSection {
  title: string
  links: FooterLink[]
}

export interface FooterProps {
  brandName: string
  description: string
  sections?: FooterSection[]
  copyright?: string
  builtWith?: string
}

withDefaults(defineProps<FooterProps>(), {
  sections: () => [],
  copyright: 'FicPod. All rights reserved.',
  builtWith: 'Built with GLM-5'
})
</script>

<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__grid">
        <div>
          <h3 class="footer__section-title">{{ brandName }}</h3>
          <p class="text-cream/80 text-sm">{{ description }}</p>
        </div>
        
        <div v-for="section in sections" :key="section.title">
          <h4 class="footer__section-subtitle">{{ section.title }}</h4>
          <ul class="footer__list">
            <li v-for="link in section.links" :key="link.label">
              <router-link v-if="link.to" :to="link.to" class="footer__link">{{ link.label }}</router-link>
              <a v-else-if="link.href" :href="link.href" class="footer__link">{{ link.label }}</a>
            </li>
          </ul>
        </div>
      </div>
      
      <div class="footer__bottom">
        <p>&copy; {{ new Date().getFullYear() }} {{ copyright }}</p>
        <p v-if="builtWith" class="footer__copyright">{{ builtWith }}</p>
      </div>
    </div>
  </footer>
</template>
